<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 조제 신청</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>입고주문코드</span></th>
                  <td>{{regData.promise_goods_cd}}</td>
                </tr>
                <tr>
                  <th><span class="emp">약속상품명</span></th>
                  <td>
                    {{regData.promise_goods_nm}}
                  </td>
                </tr>              
                <tr>
                  <th><span class="emp">상품타입</span></th>
                  <td>
                    {{ regData.promise_goods_type_nm}}             
                  </td>
                </tr>                                                          
                <tr>
                  <th><span class="emp">조제단위</span></th>
                  <td>
                     {{ regData.prepare_unit_nm}}           
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">약재</span></th>
                  <td>
                    <div class="table_list">
                      <div class="table_option">
                        <div class="form_select">
                          <button class="btn btn_md btn_blue" @click="fn_call_medcineModal">약재 추가</button>
                        </div>
                        <button class="btn btn_md btn_blue" @click="fn_call_myPromiseGoodsModal">내 처방 불러오기</button>
                          
                      </div>
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>약재명</th>
                            <th>제약회사</th>
                            <th>원산지</th>
                            <th>약재량</th>
                            <th>처리</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="regData.promiseGoodMedList.length == 0">
                              <td colspan="6"><span>데이터가 없습니다.</span></td>
                          </tr>
                          <tr v-for="(item, index) in regData.promiseGoodMedList" :key="index" :class="item.lack == true ? 'error' : ''">
                            <td><span>{{ item.med_hrb_nm }}</span></td>
                            <td><span>{{ item.company_nm }}</span></td>
                            <td><span>{{ item.org_plce_nm }}</span></td>
                            <td>
                              <input type="text" class="form_control xl_limit" v-model="item.med_use_qnty">
                              <span>g</span>
                            </td>
                            <td><button class="icon icon_del" @click="fn_medicine_delete(index)"></button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="ar pb20">
                        <button
                            class="btn btn_md btn_darkbrown btn_outline mr10"
                            @click="fn_medicine_init"
                        >
                            처방초기화
                        </button> 
                        <button class="btn btn_md btn_darkbrown" @click="fn_reg_my_promiseGoods">내 약속상품 등록</button>
                    </div>
                  </td>
                </tr>                   
                <tr>
                  <th><span class="emp">제조수량</span></th>
                  <td>
                    <input type="number" class="form_control" placeholder="입력해주세요." v-model.number="regData.produce_quantity">
                  </td>
                </tr> 
                <tr>
                  <th><span class="emp">유통기한</span></th>
                  <td>
                      <Datepicker v-model="regData.exprDt" :defaultDate="regData.exprDt" :format="'YYYY-MM-DD'"/>
                  </td>
                </tr> 
                <tr v-if="regData.status != ''">
                  <th><span>폐기여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio" checked :value="Y" v-model="regData.useDpslYn"> 
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio" :value="N" v-model="regData.useDpslYn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr> 
                <tr v-if="regData.status != ''">
                  <th><span>폐기량</span></th>
                  <td>{{regData.useDpslQnty}}</td>
                </tr> 
                <tr>
                  <th><span>비고</span></th>
                  <td>
                    <textarea class="form_control" placeholder="입력해주세요."></textarea>
                  </td>
                </tr>                
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_save">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <MedicineCompanySearch 
        :title="'약속상품 약재 검색'"
        :searchName="'약재명'" 
        :btnLeft="'선택'" 
        :btnRight="'취소'" 
        :oneBtn="true"
        @callback="fn_callback"
      />
      <MyPromiseGoodsSearch 
        :title="'내 약속상품 검색'"
        :searchName="'내 약속상품명'" 
        :btnLeft="'선택'" 
        :btnRight="'취소'" 
        :oneBtn="true"
        @callback="fn_promiseGoods_callback"
      />
      <MyPromiseGoodsRegModal 
          :title="'내 약속상품 등록'"
          :produce_quantity="regData.produce_quantity"  
          :myPromiseGoodsMedList="regData.promiseGoodMedList"
          @callback="fn_change_produce_quantity"                
      />
      <AlertModal 
            :id="'confirm'"
            :text="'저장하시겠습니까?'" 
            :btnLeft="'취소'" 
            :btnRight="'확인'" 
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />
        <AlertModal 
            :id="'alert'"
            :text="'저장되었습니다.'" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="alertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        /> 
    </div>
</template>

<script>
  import axios from 'axios'
  import MedicineCompanySearch from "@/modal/common/medicineCompanySearch.vue"
  import MyPromiseGoodsSearch from "@/modal/admin/myPromiseGoodsSearch.vue"
  import MyPromiseGoodsRegModal from "@/modal/admin/myPromiseGoodsRegModal.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import AlertModal from "@/modal/admin/alertModal.vue"

  export default {
    name: 'promiseGoodsWrhstReg',
    components: {
      MedicineCompanySearch,
      MyPromiseGoodsSearch,
      MyPromiseGoodsRegModal,
      Datepicker,
      AlertModal
    },
    data() {
      return {
        regData : {
          promise_goods_cd : '',
          promise_goods_nm : '',
          promise_goods_type : null,
          promise_goods_type_nm : '',
          promise_goods_quantity : '',
          prepare_unit : null,
          prepare_unit_nm : '',
          produce_quantity : 0,
          exprDt : '',
          note : '',
          useDpslYn : 'N',
          promiseGoodMedList : [],
          status : ''
        },
        myPromiseGoodsRegData : {},                   //내 약속상품 등록 정보
        comfirmAlertShow : false,
        alertShow : false
      }
    },
        async created(){
          
          this.regData.promise_goods_cd = this.$store.getters['commonStore/getMainCode'];
          this.regData.status = this.$store.getters['commonStore/getStatus'];    

          this.fn_search(); 
    },
    methods : {
      fn_search(){

        let param = new Object();
        param.promise_goods_cd = this.regData.promise_goods_cd;

        console.log("@@@@ param : %o",param);

        axios
            .post("/api/admin/promise/promiseGoodsDetail", param)
            .then((res) => {
                console.log("@@@@ dtl res : %o",res);
              
                this.regData.promise_goods_nm = res.data.promise_goods_nm;
                this.regData.promise_goods_source = res.data.promise_goods_source;
                this.regData.promise_goods_type = res.data.promise_goods_type;
                this.regData.promise_goods_type_nm = res.data.promise_goods_type_nm;
                this.regData.promise_goods_quantity = res.data.promise_goods_quantity;
                this.regData.prepare_unit = res.data.prepare_unit;
                this.regData.prepare_unit_nm = res.data.prepare_unit_nm;
                this.regData.produce_quantity = 0;
            })
            .catch((err) => console.log(err));
              
      },
      fn_call_medcineModal(){
        this.$bvModal.show("medicineCompanySearch");
      },
      fn_callback (medObject){
        //medObject.use_qy = 0;
        medObject.lack = false;
        this.regData.promiseGoodMedList.push(medObject);            
		  },
      fn_medicine_delete(idx){
          this.regData.promiseGoodMedList.splice(idx,1);
      },
      fn_call_myPromiseGoodsModal(){

        this.$bvModal.show("myPromisGoodsSearch");
        
      },
      fn_search_init(){

      },
      fn_reg_my_promiseGoods(){

        if(this.regData.promiseGoodMedList.length < 1){
          alert("약재정보가 없습니다.");
        }else{
          this.$bvModal.show("myPromiseGoodsRegModal"); 
        }

      },
      fn_change_produce_quantity(produce_quantity){
        this.regData.produce_quantity = produce_quantity;
      },
      fn_move_page(){
        this.$router.push("/admin/promise/promiseGoodsWrhsMngt");
      },
      fn_promiseGoods_callback(medList, cnt){
        
        this.regData.promiseGoodMedList = medList;
        this.regData.produce_quantity = cnt;

      },
      fn_medicine_init(){
        this.regData.promiseGoodMedList = [];
      },
      fn_save(){

        if(this.regData.promiseGoodMedList == null || this.regData.promiseGoodMedList.length < 1){
          alert("제조할 약재정보가 없습니다.");
          return;
        }

        if(this.regData.produce_quantity == 0 || this.regData.produce_quantity == ''){
          alert("제조수량을 입력해주세요");
          return;
        }

        if(this.regData.exprDt == null || this.regData.exprDt == ''){
          alert("유통기한을 입력해주세요");
          return;
        }

        //약재 재고량 체크
        // axios
        //   .post("/api/admin/promiseGoodsWrhs/checkPromiseGoodsMedWrhs", this.regData)
        //   .then((res) => {
        //       if(res.data.result == 'ok'){

        //         for(let i = 0; i < this.regData.promiseGoodMedList.length; i++){
        //           this.regData.promiseGoodMedList[i].lack = false;
        //         }
                this.comfirmAlertShow = true;
              // }else{
              //   alert("약재 재고가 없습니다.");

              //   //약재 정보에 줄처리
              //   for(let i = 0; i < this.regData.promiseGoodMedList.length; i++){

              //     this.regData.promiseGoodMedList[i].lack = false;

              //     for(let j = 0; j < res.data.lackList.length; j++){
                  
              //       //재고 부족 약재 처러
              //       if(this.regData.promiseGoodMedList[i].med_hrb_cd == res.data.lackList[j].med_hrb_cd &&
              //         this.regData.promiseGoodMedList[i].med_hrb_dtl_seq == res.data.lackList[j].med_hrb_dtl_seq 
              //       ){
              //         this.regData.promiseGoodMedList[i].lack = true;
              //       }
              //     }

              //     //스타일 적용처리
              //     this.$forceUpdate();
              //   }

              // }
              
          //})
          //.catch((err) => console.log(err));
      },
      fn_alert_close(type){
                
          console.log("@@@@ type : "+type);

          if(type == 'hide'){
              this.comfirmAlertShow = false;                       
          }else if(type == 'ok'){
              this.comfirmAlertShow = false;
              
              console.log("@@@@ regData reg : %o",this.regData); 

              axios
                  .post("/api/admin/promiseGoodsWrhs/regPromiseGoodsWrhs", this.regData)
                  .then((res) => {
                      this.alertShow = true;
                  })
                  .catch((err) => console.log(err));

          }else if(type == 'close'){
              this.alertShow = false;
              this.$router.push("/admin/promise/promiseGoodsWrhsMngt");
          }
      }
    }
  }
</script>